import { html, TemplateResult } from "lit-html";
import LawComplianceComponent from "@components/lawcompliance";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { classMap } from "lit-html/directives/class-map";
import WhatField from "@components/modal/subscriptionProposal/whatField";
import LocationTypeaheadComponent from "@components/typeahead/location";
import ButtonField from "@components/modal/subscriptionProposal/buttonField";

const FormTemplate = async (props: ProposalConfigs, model: IProposalModel): Promise<TemplateResult> => {

  const {
    messages,
    feature: {
      distanceFilterEnabled = false,
    }
  } = props;

  const {
    loading,
    handleSubmit,
    handleWhatInput,
    handleWhereInput,
    handleClearWhatInput,
    formData,
    formSubmitted
  } = model;

  const formClasses = {
    'no-distance-filter': !distanceFilterEnabled,
    'proposal-form--empty-search': !formData.what.value && !formData.where.value
  };

  const formFieldClasses = {
    'proposal-form__field--error': formSubmitted && (!formData.what.value && !formData.where.value)
  };


  const lawComplianceProps: ILawComplianceComponent = {
    messages,
    captchaEnabled: false
  }

  const whatFieldParams: IWhatField = {
    loading,
    messages,
    formData,
    handleWhatInput,
    handleClearWhatInput,
  };

  const locationTypeaheadProps: ILocationTypeaheadProps = {
    isLocationLabelEnabled: true,
    locationValue: formData.where.value,
    locationTypeaheadFor: 'proposal-modal',
    placeholder: messages.SearchWhere,
    cssClasses: 'jr-input jr-input--autocomplete jr-input-material',
    labelText: messages.ProposalPopupLocationLabel,
    onLocationChange: handleWhereInput,
  }


  const submitButtonParams: ISubmitButton = {
    loading,
    additionalClass: '',
    messages,
  }

  return html`
    <h4 class="go-to-mail__title">
      ${unsafeHTML(messages.JobSeekerSubscriptionExtendedDialogTitle)}
    </h4>
    <p class="go-to-mail__description">
      ${unsafeHTML(messages.JobSeekerSubscriptionExtendedDialogInfo)}
    </p>
    <form class="proposal-form ${classMap(formClasses)}" name="forms.proposal" novalidate @submit=${handleSubmit}>
      <div class="proposal-form--error-message">
        <span>${unsafeHTML(messages.JobSeekerSubscriptionDialogInvalidWLWarn)}</span>
      </div>
      <div class="proposal-form__field ${classMap(formFieldClasses)}"> 
        ${WhatField(whatFieldParams)}
      </div>
      <div class="proposal-form__field">
        ${await LocationTypeaheadComponent(locationTypeaheadProps)}
      </div>  
      ${ButtonField(submitButtonParams)}
    </form>
    ${LawComplianceComponent(lawComplianceProps)}
    `;
}

export default FormTemplate;